import { render, staticRenderFns } from "./AddLabourerPage.vue?vue&type=template&id=2ab8d9a8&scoped=true&"
import script from "./AddLabourerPage.vue?vue&type=script&lang=js&"
export * from "./AddLabourerPage.vue?vue&type=script&lang=js&"
import style0 from "./AddLabourerPage.vue?vue&type=style&index=0&id=2ab8d9a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8d9a8",
  null
  
)

export default component.exports